
    <div class="settinginfo">
      <h2>Welcome to the Field Settings Page</h2>
      <p>Drag and drop the handle on the left to sort field order. These changes will be reflected for every user in
        your organization.</p>
    </div>
   
    <mat-tab-group animationDuration="0ms" (selectedTabChange)="getSubFolder($event)" [selectedIndex]="0">
      <mat-tab *ngFor="let folder of folderListPermission; let count = index" label="{{ folder.orgModuleName }}">
        <ng-template mat-tab-label>
          {{ folder.orgModuleName }}       
        </ng-template>

        <app-people *ngIf="peopleTypeIndex == count && peopleTypeIndex != folderCount" (openSlide)="getcreateField($event)"
          (openEditSlide)="getopenEditSlide($event)">
        </app-people>

        <app-edit-custom-field *ngIf="peopleTypeIndex == folderCount" (openEditSlide)="getopenEditSlide($event)">
        </app-edit-custom-field>
        
      </mat-tab>

    
    </mat-tab-group>


<app-create-field  (closeSlide)="closecreateField($event)" [ngClass]="{ open: showSidePanel }"></app-create-field>


<app-edit-field (closeEditSlide)="closeEditSlide($event)" [ngClass]="{ open: showEditPanel }" *ngIf="showEditPanel">
</app-edit-field>


<ng-template #myDialog>
  <h2 matDialogTitle>Create Contact Type</h2>
  <mat-dialog-content>
    <form [formGroup]="addFolderForm">
      <mat-form-field class="example-full-width">
        <mat-label>Contact Type</mat-label>
        <input matInput placeholder="Add Type" formControlName="folderName" />
        <mat-error>
          Folder Name is required
        </mat-error>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
    <button mat-button  color="" (click)="close()">Close</button>
    <button mat-button  color="primary" (click)="createFolder(addFolderForm.value)">
      Create
    </button>
  </mat-dialog-actions>
</ng-template>

<app-loader></app-loader>